export default "__VITE_PUBLIC_ASSET__b9b36f0a__"